import React, { useEffect, useLayoutEffect, useRef, useState } from "react"
import { FaChevronDown } from "react-icons/fa"
import clsx from "clsx"

import { thousandSeparator } from "utils"
import { productTerms } from "constant"
import classes from "./SpCard.module.scss"

const SpCard = (props) => {
  const {
    setPage,
    planName,
    subscriptionPlans,
    setSelectedPlan,
    currentContractSubscriptionPlan
  } = props

  const [openMenu, setOpenMenu] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState(null)

  const ref = useRef(null)

  const isCurrentContractSubscriptionPlanChanged = (plan) => {
    if (plan._id !== currentContractSubscriptionPlan._id) return false

    const result =
      currentContractSubscriptionPlan.term === plan.term &&
      currentContractSubscriptionPlan.salePrice === plan.salePrice &&
      currentContractSubscriptionPlan.maximumProductNumber === plan.maximumProductNumber &&
      currentContractSubscriptionPlan.maximumBranchNumber === plan.maximumBranchNumber &&
      currentContractSubscriptionPlan.maximumAccessUserNumber === plan.maximumAccessUserNumber &&
      currentContractSubscriptionPlan.maximumStorageSpaceInByte === plan.maximumStorageSpaceInByte

    return result
  }

  const handleSubscribe = () => {
    setSelectedPlan({ ...selectedProduct })

    setPage("checkout")
  }

  const handleClickItem = (product) => {
    features = product.featured

    shortDescription = product.shortDescription

    setSelectedProduct({ ...product })

    setOpenMenu(false)
  }

  const windowListenToClicks = (e) => {
    !ref.current?.contains(e.target) &&
      setOpenMenu(false)
  }

  useEffect(() => {
    window.addEventListener("click", windowListenToClicks)

    return () => {
      window.removeEventListener("click", windowListenToClicks)
    }
  }, [])

  useLayoutEffect(() => {
    setSelectedProduct(
      subscriptionPlans[0]
    )
  }, [])

  if (selectedProduct === null) return null

  let features = selectedProduct.featured

  let shortDescription = selectedProduct.shortDescription

  const haveOtherProdutcts = subscriptionPlans.length > 1

  const showPrice =
    Number(selectedProduct.price) !==
    Number(selectedProduct.salePrice)

  return (
    <div className={classes["container"]}>
      <div>
        <div className={classes["name"]}>
          {planName}
        </div>
        <div className={classes["short-description"]}>
          {shortDescription}
        </div>
        {!productTerms[selectedProduct.term].includes("طرح") &&
          <div className={classes["price"]}>
            {
              showPrice &&
              thousandSeparator(selectedProduct.price)
            }
          </div>
        }
        <div className={classes["sale-price"]}>
          {selectedProduct.salePrice !== 0
            ?
            thousandSeparator(selectedProduct.salePrice)
            :
            <div className={classes["pay-as-you-go"]}>
              {!productTerms[selectedProduct.term].includes("طرح")
                ?
                "رایگان"
                :
                <div>
                  <div className={classes["pay-as-go-feature"]}>
                    <span className="pe-2">
                      کارمزد مشارکت <b>{selectedProduct.percentagePerOrderValue}%</b>
                    </span>
                  </div>
                  پرداخت به‌ازای استفاده
                </div>
              }
            </div>
          }
        </div>

        <div
          ref={ref}
          className={clsx(classes["terms"],
            haveOtherProdutcts && classes["pointer"])
          }
        >
          <div
            className={classes["term"]}
            onClick={() =>
              haveOtherProdutcts && setOpenMenu(prev => !prev)
            }
          >
            {productTerms[selectedProduct.term]}{" "}
            {haveOtherProdutcts > 0 && <FaChevronDown />}
          </div>

          <div
            className={clsx(
              classes["terms-menu"],
              openMenu && classes["open"]
            )}
          >
            {subscriptionPlans.map(product => (
              !isCurrentContractSubscriptionPlanChanged(product) &&
              <div
                key={product.term}
                onClick={() => handleClickItem(product)}
                className={clsx(
                  classes["menu-item"],
                  product._id === selectedProduct._id && classes["active"]
                )}
              >
                {productTerms[product.term]}
              </div>
            ))}
          </div>
        </div>

        <ul className={classes["features"]}>
          {features.map((feature, i) => (
            <li
              key={i}
              className={classes["feature"]}
            >
              {feature}
            </li>
          ))}
        </ul>
      </div>

      <div className={classes["buttons"]}>
        <button
          className={classes["button"]}
          onClick={handleSubscribe}
        >
          انتخاب تعرفه
        </button>
      </div>
    </div >
  )
}

export default SpCard
